exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "h1[data-v-945540a2]{margin-bottom:20px;padding-top:15px;font-weight:700}.row[data-v-945540a2]{display:flex;flex-direction:row;justify-content:space-between;align-items:center;margin-bottom:15px}.row .radio[data-v-945540a2]{width:49%}.row .radio input[data-v-945540a2]{display:none}.row .radio input:checked+label[data-v-945540a2]{background-color:#5698d2;color:#fff}.row .radio label[data-v-945540a2]{display:flex;height:50px;text-align:center;justify-content:space-around;align-items:center;color:#999;background-color:#e2e2e2;border-radius:5px;transition:all .3s ease}.row .radio label i[data-v-945540a2]{font-size:2.3rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-945540a2","scoped":true,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/bouteille/BouteilleRegul.vue
// module id = 648
// module chunks = 0